import React, { useState, useEffect } from 'react';
import swal from "sweetalert";
import 'antd/dist/antd.css';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import dayjs from "dayjs";
import locale from 'antd/es/date-picker/locale/bn_BD';
import 'antd/dist/antd.css';
// import HrApi from '../../../../initialpage/hooks/HrApi';
// import useAuth from '../../../../initialpage/hooks/useAuth';
// import Api from '../../../../initialpage/hooks/Api';
import { useNavigate } from 'react-router-dom';
const { Option } = Select;
import {
    getCaseCategoriesApi,
    getCaseTypesByCategoryApi,
    getJusticeNamesApi,
    getLawOfficersApi,
    getLawOfficerNamesByOfficerApi,
    createAppealCourtEntryApi,
    getHighCourtTypeApi,
    getCaseNumberByTypeApi
} from "../../../../api/master.api";
import { uploadGeneralCaseFileApi } from "../../../../api/uploadFile.api";
const AppelCaseGenralForm = () => {
    // const { user } = useAuth();
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        case_category: '',
        case_type: '',
        case_number: '',
        case_year: '',
        filing_date: '',
        appelier: '',
        caseType1: '',
        source_case_entry_id: '',
        justiceNames: [{ name: '' }],
        relatedOfficers: [{ officer: '', name: '' }],
        case_description: '',
        hc_admin_case_no: '',
        petitioner_name: '',
        case_subject_summary: '',
        order_details: '',
        order_date: '',
        documents: [{ name: '', file: '' }],
        hearingDates: [{ lastHearingDate: '', nextHearingDate: '', comment: '' }],
        ha_case_court_name: '',
        ha_case_justice_name: '',
        rule_issue_date: '',
    });
    const [errors, setErrors] = useState({});
    console.log(formData)
    // State for API options
    const [courtCategoryOptions, setCourtCategoryOptions] = useState([]);
    const [caseTypeOptions, setCaseTypeOptions] = useState([]);
    const [justiceOptions, setJusticeOptions] = useState([]);
    const [officerOptions, setOfficerOptions] = useState([]);
    const [caseType1Options, setCaseType1Options] = useState([]);
    const [caseNumber1Options, setCaseNumber1Options] = useState([]);


    // Fetch Court Category Data
    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getCaseCategoriesApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.category_id,
                    label: item.category_name,
                }));
                setCourtCategoryOptions(options);
            } catch (err) {
                console.error(err);
            }
        };
        getCategories();
    }, []);

    // Fetch Case Type Data based on selected category
    useEffect(() => {
        const getCaseTypes = async () => {
            try {
                const res = await getCaseTypesByCategoryApi(formData.case_category);
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.case_type_id,
                    label: item.case_type_name,
                }));
                setCaseTypeOptions(options);
            } catch (err) {
                console.error(err);
            }
        };
        if (formData.case_category) {
            getCaseTypes();
        }
    }, [formData.case_category]);




    // Fetch Justice Options
    useEffect(() => {
        const getJustice = async () => {
            try {
                const res = await getJusticeNamesApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.justice_id,
                    label: item.justice_name,
                }));
                setJusticeOptions(options);
            } catch (err) {
                console.error(err);
            }
        };
        getJustice();
    }, []);

    // Fetch Officer Options
    useEffect(() => {
        const getOfficers = async () => {
            try {
                const res = await getLawOfficersApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.law_officer_id,
                    label: item.law_officer_name,
                }));
                setOfficerOptions(options);
            } catch (err) {
                console.error(err);
            }
        };
        getOfficers();
    }, []);


    useEffect(() => {
        const getCaseTypes1 = async () => {
            try {
                const res = await getHighCourtTypeApi(1, 100, '');
                // console.log("res", res)
                const items = res.data?.data ?? [];
                // console.log("items", items)
                const options = items.map((item) => ({
                    value: item.case_type_id,
                    label: item.case_type_name,
                }));
                setCaseType1Options(options);
            } catch (err) {
                console.error(err);
            }
        };
        getCaseTypes1();
    }, []);


    // Fetch Case Number 1 Options (for related cases)
    useEffect(() => {
        const getCaseNumbers1 = async () => {
            try {
                const res = await getCaseNumberByTypeApi(formData.caseType1);
                // console.log("res", res)
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.case_entry_id,
                    label: item.case_number,
                }));
                setCaseNumber1Options(options);
            } catch (err) {
                console.error(err);
            }
        };
        if (formData.caseType1) {
            getCaseNumbers1();
        }
    }, [formData.caseType1]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => {
            const next = { ...prev };
            // clear primitive field error on change
            if (next[field]) {
                delete next[field];
            }
            return next;
        });
    };
    const handleDateChange = (field, date) => {
        if (date && moment.isMoment(date) && date.isValid()) {
            handleInputChange(field, date.format('YYYY-MM-DD'));
        } else if (date === null) {
            handleInputChange(field, '');
        } else {
            console.warn('Invalid date selected:', date);
            handleInputChange(field, '');
        }
    };

    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };
    const addJustice = () => {
        setFormData(prev => ({
            ...prev,
            justiceNames: [...prev.justiceNames, { name: '' }]
        }));
    };

    const removeJustice = (index) => {
        if (formData.justiceNames.length > 1) {
            setFormData(prev => ({
                ...prev,
                justiceNames: prev.justiceNames.filter((_, i) => i !== index)
            }));
        }
    };

    const updateJustice = (index, value) => {
        const newJustices = [...formData.justiceNames];
        newJustices[index] = { name: value };
        setFormData(prev => ({
            ...prev,
            justiceNames: newJustices
        }));
        setErrors(prev => {
            if (!prev.justiceNames) return prev;
            const nextArr = [...prev.justiceNames];
            nextArr[index] = false;
            return { ...prev, justiceNames: nextArr };
        });
    };
    const addOfficer = () => {
        setFormData(prev => ({
            ...prev,
            relatedOfficers: [...prev.relatedOfficers, { officer: '', name: '' }]
        }));
    };

    const removeOfficer = (index) => {
        if (formData.relatedOfficers.length > 1) {
            setFormData(prev => ({
                ...prev,
                relatedOfficers: prev.relatedOfficers.filter((_, i) => i !== index)
            }));
        }
    };

    const updateOfficer = async (index, field, value) => {
        const newOfficers = [...formData.relatedOfficers];
        newOfficers[index] = { ...newOfficers[index], [field]: value };

        // Officer change হলে API call করো
        if (field === "officer" && value) {
            try {
                const res = await getLawOfficerNamesByOfficerApi(value);
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.officer_name_id,
                    label: item.officer_name,
                }));

                // nameOptions বসিয়ে দাও
                newOfficers[index].nameOptions = options;
                newOfficers[index].name = ""; // নতুন officer select হলে name reset
            } catch (err) {
                console.error(err);
            }
        }

        setFormData(prev => ({
            ...prev,
            relatedOfficers: newOfficers
        }));
        setErrors(prev => {
            if (!prev.relatedOfficers) return prev;
            const nextArr = prev.relatedOfficers.map((e, i) => ({ ...(e || {}), officer: false, name: false }));
            return { ...prev, relatedOfficers: nextArr };
        });
    };


    const addHearingDate = () => {
        console.log(formData);
        setFormData(prev => ({
            ...prev,
            hearingDates: [...prev.hearingDates, { lastHearingDate: '', nextHearingDate: '', comment: '' }]
        }));
    };

    const removeHearingDate = (index) => {
        if (formData.hearingDates.length > 1) {
            setFormData(prev => ({
                ...prev,
                hearingDates: prev.hearingDates.filter((_, i) => i !== index)
            }));
        }
    };

    const updateHearingDate = (index, field, value) => {
        const newHearingDates = [...formData.hearingDates];
        newHearingDates[index] = { ...newHearingDates[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            hearingDates: newHearingDates
        }));
    };




    // Add new document
    const addDocument = () => {
        setFormData({
            ...formData,
            documents: [...formData.documents, { name: '', file: '' }]
        });
    };

    // Remove document
    const removeDocument = (index) => {
        const updatedDocs = [...formData.documents];
        updatedDocs.splice(index, 1);
        setFormData({ ...formData, documents: updatedDocs });
    };


    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
        },
        header: {
            backgroundColor: '#f3f4f6',
            padding: '12px 16px',
            borderBottom: '1px solid #e5e7eb'
        },
        headerTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#1f2937',
            margin: 0
        },
        tabNav: {
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            display: 'flex',
            overflowX: 'auto'
        },
        tabButton: {
            padding: '12px 16px',
            fontSize: '12px',
            fontWeight: '500',
            borderBottom: '2px solid transparent',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
        },
        activeTabButton: {
            borderBottomColor: '#3b82f6',
            color: '#2563eb',
            backgroundColor: 'white'
        },
        inactiveTabButton: {
            color: '#4b5563'
        },
        warningBox: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#b91c1c'
        },
        formInput: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px'
        },
        searchableSelect: {
            width: '100%',
            height: '36px'
        },
        textarea: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'none'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '4px'
        },
        datePicker: {
            width: '100%',
            height: '36px'
        },
        removeButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        addButton: {
            marginTop: '8px',
            padding: '4px 12px',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        helpIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#3b82f6',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        warningIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#ef4444',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        uploadSection: {
            backgroundColor: '#ecfeff',
            border: '1px solid #67e8f9',
            padding: '12px',
            marginBottom: '16px'
        },
        uploadHeader: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#155e75',
            marginBottom: '12px'
        },
        submitButton: {
            padding: '8px 24px',
            backgroundColor: '#0d9488',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        greenAddButton: {
            width: '24px',
            height: '24px',
            backgroundColor: '#16a34a',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        browseButton: {
            padding: '8px 12px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        errorText: {
            color: '#b91c1c',
            fontSize: '12px',
            marginTop: '4px'
        }
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const nextErrors = {};

        // Required field validations
        if (!formData.case_category) nextErrors.case_category = true;
        if (!formData.case_type) nextErrors.case_type = true;
        if (!formData.case_number) nextErrors.case_number = true;
        if (!formData.case_year) nextErrors.case_year = true;
        if (!formData.appelier) nextErrors.appelier = true;

        // Justice required: at least one selected


        // Related officer: require at least one row with both fields
        const officerValidity = formData.relatedOfficers.map(r => ({
            officer: !!r.officer,
            name: !!r.name
        }));
        const hasValidOfficerRow = officerValidity.some(v => v.officer && v.name);
        if (!hasValidOfficerRow) {
            nextErrors.relatedOfficers = formData.relatedOfficers.map(r => ({
                officer: !r.officer,
                name: !r.name
            }));
        }

        // Additional required fields in the conditional section
        // if (!formData.hc_admin_case_no) nextErrors.hc_admin_case_no = true;
        // if (!formData.petitioner_name) nextErrors.petitioner_name = true;
        // if (!formData.order_date) nextErrors.order_date = true;

        setErrors(nextErrors);

        const hasPrimitiveErrors = Object.keys(nextErrors).some(
            key => !Array.isArray(nextErrors[key]) && nextErrors[key]
        );

        const hasOfficerErrors = Array.isArray(nextErrors.relatedOfficers) && nextErrors.relatedOfficers.some(v => v.officer || v.name);

        const hasAnyError = hasPrimitiveErrors || hasOfficerErrors;
        if (hasAnyError) return alert('Please fill out all required fields.');
        try {
            // 🔹 Upload all document files and get URLs
            const uploadedDocs = await Promise.all(
                formData.documents.map(async (doc) => {
                    if (doc.file) {
                        const res = await uploadGeneralCaseFileApi(doc.file);
                        const fileUrl = res.data?.data?.fileUrl;
                        return { ...doc, url: fileUrl, file: '' };
                    }
                    return doc;
                })
            );

            // 🔹 Final data with uploaded document URLs
            const finalData = {
                ...formData,
                // created_by: user?.employe_id,
                documents: uploadedDocs,
                court_type_id: 7
            };

            console.log("Final submit payload:", finalData);

            // 🔹 Submit case entry
            const res = await createAppealCourtEntryApi(finalData);
            if (res.data?.success) {
                swal({
                    title: "Thank you",
                    text: "Successfully Added",
                    icon: "success",
                    button: "Ok",
                });
                navigate("/report/appeal-court/all-case");
                console.log('Form submitted successfully:', formData);
                setFormData({
                    case_category: '',
                    case_type: '',
                    case_number: '',
                    case_year: '',
                    filing_date: '',
                    appelier: '',
                    caseType1: '',
                    source_case_entry_id: '',
                    justiceNames: [{ name: '' }],
                    relatedOfficers: [{ officer: '', name: '' }],
                    case_description: '',
                    hc_admin_case_no: '',
                    petitioner_name: '',
                    case_subject_summary: '',
                    order_details: '',
                    order_date: '',
                    documents: [{ name: '', file: '' }],
                    hearingDates: [{ lastHearingDate: '', nextHearingDate: '', comment: '' }],
                    ha_case_court_name: '',
                    ha_case_justice_name: '',
                    rule_issue_date: ''
                });
            }
        } catch (err) {
            console.error("Submit failed:", err);
            alert("Something went wrong while submitting.");
        }
        // If no errors, proceed with form submission

        // Add your form submission logic here
    };

    return (
        <div style={{ backgroundColor: 'white', textAlign: 'left' }}>
            {/* First Row - Three columns */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার ক্যাটেগরি *
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.case_category || undefined}
                        onChange={(value) => handleInputChange('case_category', value)}
                        status={errors.case_category ? 'error' : ''}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {courtCategoryOptions.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    {errors.case_category && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}
                </div>

                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার শ্রেণী/কেস-টাইপ *
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.case_type || undefined}
                        onChange={(value) => handleInputChange('case_type', value)}
                        status={errors.case_type ? 'error' : ''}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {caseTypeOptions.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    {errors.case_type && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}
                </div>

                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার নং *
                    </label>
                    <input
                        type="text"
                        placeholder="(Type digits in English)"
                        style={{ ...styles.formInput, borderColor: errors.case_number ? '#ef4444' : '#d1d5db' }}
                        value={formData.case_number}
                        onChange={(e) => handleInputChange('case_number', e.target.value)}
                    />
                    {errors.case_number && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)}
                </div>
            </div>
            {/* Second Row - Two columns */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label style={styles.label}>
                        বছর *
                    </label>
                    <DatePicker
                        picker="year"
                        placeholder="--- নির্বাচন করুন ---"
                        style={{ width: "100%" }}
                        value={formData.case_year ? dayjs(formData.case_year, "YYYY") : null}
                        onChange={(date, dateString) =>
                            handleInputChange("case_year", dateString) // returns only case_year string like "2025"
                        }
                        status={errors.case_year ? 'error' : ''}
                    />
                    {errors.case_year && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}


                </div>

                <div className="col-md-4 ">
                    <label style={styles.label}>
                        আপিলকারী *
                    </label>
                    <input
                        type="text"
                        placeholder="(Type in English)"
                        style={{ ...styles.formInput, borderColor: errors.appelier ? '#ef4444' : '#d1d5db' }}
                        value={formData.appelier}
                        onChange={(e) => handleInputChange('appelier', e.target.value)}
                    />
                    {errors.appelier && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)}

                </div>
                <div className="col-md-4 ">
                    <label style={styles.label}>
                        আদালতের নাম
                    </label>
                    <input
                        type="text"
                        style={styles.formInput}
                        value={formData.ha_case_court_name}
                        onChange={(e) => handleInputChange('ha_case_court_name', e.target.value)}
                    />
                </div>
                <div className="col-md-4 mt-3">
                    <label style={styles.label}>
                        Justice Name
                    </label>
                    <input
                        type="text"
                        style={styles.formInput}
                        value={formData.ha_case_justice_name}
                        onChange={(e) => handleInputChange('ha_case_justice_name', e.target.value)}
                    />
                </div>
                {/* Justice Names Section - Multiple */}
                {/* <div className="col-md-4 border p-2">
                    <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        আদালতের নাম (Justice Name)*
                        <span style={styles.helpIcon}>?</span>
                        <button
                            type="button"
                            className='bg-success text-white ms-2'
                            onClick={addJustice}
                            style={styles.addButton}
                        >
                            <i className="fa fa-plus" style={{ fontSize: '14px' }}></i>
                        </button>
                    </label>
                    {formData.justiceNames.map((justice, index) => (
                        <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <Select
                                style={{ ...styles.searchableSelect, flex: '1' }}
                                placeholder="--- নির্বাচন করুন ---"
                                value={justice.name || undefined}
                                onChange={(value) => updateJustice(index, value)}
                                status={Array.isArray(errors.justiceNames) && errors.justiceNames[index] ? 'error' : ''}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {justiceOptions.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                            <button
                                type="button"
                                onClick={() => removeJustice(index)}
                                style={styles.removeButton}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                            >
                                <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                            </button>
                        </div>
                    ))}
                    {Array.isArray(errors.justiceNames) && errors.justiceNames.every(Boolean) && (
                        <div style={styles.errorText}>কমপক্ষে একটি আদালতের নাম নির্বাচন করুন</div>
                    )}
                </div> */}


                <div className="col-md-4 mt-3">
                    <label style={styles.label}>
                        মামলা দায়েরের তারিখ
                    </label>
                    <DatePicker
                        style={styles.datePicker}
                        placeholder="দিন/মাস/বছর"
                        value={getSafeDateValue(formData.filing_date)}
                        onChange={(date) => handleDateChange('filing_date', date)}
                        format="DD/MM/YYYY"
                        locale={locale}
                        allowClear={true}
                        inputReadOnly={false}
                        showToday={true}
                        showTime={false}
                        status={(formData.filing_date && !getSafeDateValue(formData.filing_date)) ? 'error' : ''}
                        onBlur={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue) {
                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                if (parsedDate.isValid()) {
                                    handleDateChange('filing_date', parsedDate);
                                }
                            }
                        }}
                    />

                </div>
                <div className="col-md-4 mt-3">
                    <label style={styles.label}>
                        রুল ইস্যুর তারিখ
                    </label>
                    <DatePicker
                        style={styles.datePicker}
                        placeholder="দিন/মাস/বছর"
                        value={getSafeDateValue(formData.rule_issue_date)}
                        onChange={(date) => handleDateChange('rule_issue_date', date)}
                        format="DD/MM/YYYY"
                        locale={locale}
                        allowClear={true}
                        inputReadOnly={false}
                        showToday={true}
                        showTime={false}
                        status={(formData.rule_issue_date && !getSafeDateValue(formData.rule_issue_date)) ? 'error' : ''}
                        onBlur={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue) {
                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                if (parsedDate.isValid()) {
                                    handleDateChange('rule_issue_date', parsedDate);
                                }
                            }
                        }}
                    />

                </div>


            </div>
            {/* Related Officers Section - Multiple */}
            <div style={{ marginBottom: '16px' }} className=" border p-2">
                <div className="row mb-2 ">
                    <div className="col-md-6">
                        <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            সংশ্লিষ্ট আইন কর্মকর্তা *
                        </label>
                        {Array.isArray(errors.relatedOfficers) && errors.relatedOfficers.some(e => e.officer) && (
                            <div style={styles.errorText}>কমপক্ষে একজন কর্মকর্তাকে নির্বাচন করুন</div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            সংশ্লিষ্ট আইন কর্মকর্তার নাম *
                            <span style={styles.helpIcon}>?</span>
                        </label>
                        {Array.isArray(errors.relatedOfficers) && errors.relatedOfficers.some(e => e.name) && (
                            <div style={styles.errorText}>কমপক্ষে একটি নাম নির্বাচন করুন</div>
                        )}
                    </div>
                </div>


                {formData.relatedOfficers.map((officer, index) => (
                    <div key={index} className="row mb-2">
                        <div className="col-md-6">
                            <Select
                                style={styles.searchableSelect}
                                placeholder="--- নির্বাচন করুন ---"
                                value={officer.officer || undefined}
                                onChange={(value) => updateOfficer(index, 'officer', value)}
                                status={Array.isArray(errors.relatedOfficers) && errors.relatedOfficers[index] && errors.relatedOfficers[index].officer ? 'error' : ''}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {officerOptions.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div className="col-md-6">
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Select
                                    style={{ ...styles.searchableSelect, flex: '1' }}
                                    placeholder="--- নির্বাচন করুন ---"
                                    value={officer.name || undefined}
                                    onChange={(value) => updateOfficer(index, 'name', value)}
                                    status={Array.isArray(errors.relatedOfficers) && errors.relatedOfficers[index] && errors.relatedOfficers[index].name ? 'error' : ''}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    allowClear
                                >
                                    {(officer.nameOptions || []).map(option => (
                                        <Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Option>
                                    ))}
                                </Select>
                                <button
                                    type="button"
                                    onClick={() => removeOfficer(index)}
                                    style={styles.removeButton}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                <button
                    type="button"
                    onClick={addOfficer}
                    className="bg-success"
                    style={styles.addButton}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                    আরও যোগ করুন
                </button>
            </div>



            {/* Case Description */}
            <div style={{ marginBottom: '16px' }}>
                <label style={styles.label}>
                    স্থগিতাদেশের বিবরণ
                </label>
                <textarea
                    style={{ ...styles.textarea, height: '128px' }}
                    value={formData.case_description}
                    onChange={(e) => handleInputChange('case_description', e.target.value)}
                />
            </div>


            {/* Third Row - Three columns */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label style={styles.label}>
                        যে মামলা হতে উদ্ভূত তার শ্রেণী/কেস-টাইপ
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.caseType1 || undefined}
                        onChange={(value) => handleInputChange('caseType1', value)}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {caseType1Options.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div className="col-md-6">
                    <label style={styles.label}>
                        মামলা নং(যে মামলা হতে উদ্ভূত তার মামলা নং)
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.source_case_entry_id || undefined}
                        onChange={(value) => handleInputChange('source_case_entry_id', value)}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {caseNumber1Options.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </div>


            </div>
            {/* Additional Form Section */}
            <div style={{ backgroundColor: '#f8f9fa', padding: '16px', marginBottom: '16px', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                <p style={{ fontSize: '14px', color: '#495057', marginBottom: '16px', fontWeight: '500', }}>
                    <span style={{ color: '#dc3545', background: "#fef2f2", padding: '8px' }}>  আপিল মামলাটি যে মামলা হতে উদ্ভুত তা এন্ট্রি না হয়ে থাকলে নিম্নের কলামসমুহ পুরণ করুণঃ </span>
                </p>

                {/* Fourth Row - Three columns */}
                <div className="row mb-3">
                    <div className="col-md-4">
                        <label style={styles.label}>
                            হাইকোর্ট/প্রশাসনিক ট্রাইব্যুনাল মামলা নং:
                        </label>
                        <input
                            type="text"
                            placeholder="(Type digits in English)"
                            style={{ ...styles.formInput, borderColor: '#d1d5db' }}
                            value={formData.hc_admin_case_no || ''}
                            onChange={(e) => handleInputChange('hc_admin_case_no', e.target.value)}
                        />
                        {/* {errors.hc_admin_case_no && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)} */}
                    </div>

                    <div className="col-md-4">
                        <label style={styles.label}>
                            পিটিশনারের নাম:
                        </label>
                        <input
                            type="text"
                            style={{ ...styles.formInput, borderColor: '#d1d5db' }}
                            value={formData.petitioner_name || ''}
                            onChange={(e) => handleInputChange('petitioner_name', e.target.value)}
                        />
                        {/* {errors.petitioner_name && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)} */}
                    </div>

                    <div className="col-md-4">
                        <label style={styles.label}>
                            মামলার বিষয়বস্তু(সংক্ষিপ্ত):
                        </label>
                        <textarea
                            style={{ ...styles.textarea, height: '80px' }}
                            value={formData.case_subject_summary || ''}
                            onChange={(e) => handleInputChange('case_subject_summary', e.target.value)}
                        />
                    </div>
                </div>

                {/* Fifth Row - Two columns */}
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label style={styles.label}>
                            রায়/আদেশ প্রদানের তারিখ:
                        </label>
                        <DatePicker
                            style={styles.datePicker}
                            placeholder="দিন/মাস/বছর"
                            value={getSafeDateValue(formData.order_date)}
                            onChange={(date) => handleDateChange('order_date', date)}
                            format="DD/MM/YYYY"
                            locale={locale}
                            allowClear={true}
                            inputReadOnly={false}
                            showToday={true}
                            showTime={false}
                            // status={errors.order_date || (formData.order_date && !getSafeDateValue(formData.order_date)) ? 'error' : ''}
                            onBlur={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue) {
                                    const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                    if (parsedDate.isValid()) {
                                        handleDateChange('order_date', parsedDate);
                                    }
                                }
                            }}
                        />
                        {/* {errors.order_date && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)} */}

                    </div>

                    <div className="col-md-6">
                        <label style={styles.label}>
                            রায়/আদেশের বিবরণ:
                        </label>
                        <textarea
                            style={{ ...styles.textarea, height: '80px' }}
                            value={formData.order_details || ''}
                            onChange={(e) => handleInputChange('order_details', e.target.value)}
                        />
                    </div>
                </div>
            </div>


            {/* Hearing Dates Section - Multiple */}
            <div style={{ backgroundColor: '#f8f9fa', padding: '16px', marginBottom: '16px', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <p style={{ fontSize: '14px', color: '#495057', fontWeight: '500', margin: 0 }}>
                        <span style={{ color: '#dc3545', background: "#fef2f2", padding: '8px' }}>শুনানি তারিখঃ</span>
                    </p>
                    <button
                        type="button"
                        onClick={addHearingDate}
                        className='bg-success text-white'
                        style={styles.addButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                        আরও যোগ করুন
                    </button>
                </div>

                {formData.hearingDates.map((hearingDate, index) => (
                    <div key={index} style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'white', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                                শুনানি তারিখ #{index + 1}
                            </span>
                            {formData.hearingDates.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removeHearingDate(index)}
                                    style={styles.removeButton}
                                    className='ms-3'
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    সর্বশেষ শুনানির তারিখঃ
                                </label>
                                <DatePicker
                                    style={styles.datePicker}
                                    placeholder="দিন/মাস/বছর"
                                    value={getSafeDateValue(hearingDate.lastHearingDate)}
                                    onChange={(date) => {
                                        if (date && moment.isMoment(date) && date.isValid()) {
                                            updateHearingDate(index, 'lastHearingDate', date.format('YYYY-MM-DD'));
                                        } else if (date === null) {
                                            updateHearingDate(index, 'lastHearingDate', '');
                                        }
                                    }}
                                    format="DD/MM/YYYY"
                                    locale={locale}
                                    allowClear={true}
                                    inputReadOnly={false}
                                    showToday={true}
                                    showTime={false}
                                    onBlur={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue) {
                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                            if (parsedDate.isValid()) {
                                                updateHearingDate(index, 'lastHearingDate', parsedDate.format('YYYY-MM-DD'));
                                            }
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label style={styles.label}>
                                    পরবর্তী শুনানির তারিখঃ
                                </label>
                                <DatePicker
                                    style={styles.datePicker}
                                    placeholder="দিন/মাস/বছর"
                                    value={getSafeDateValue(hearingDate.nextHearingDate)}
                                    onChange={(date) => {
                                        if (date && moment.isMoment(date) && date.isValid()) {
                                            updateHearingDate(index, 'nextHearingDate', date.format('YYYY-MM-DD'));
                                        } else if (date === null) {
                                            updateHearingDate(index, 'nextHearingDate', '');
                                        }
                                    }}
                                    format="DD/MM/YYYY"
                                    locale={locale}
                                    allowClear={true}
                                    inputReadOnly={false}
                                    showToday={true}
                                    showTime={false}
                                    onBlur={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue) {
                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                            if (parsedDate.isValid()) {
                                                updateHearingDate(index, 'nextHearingDate', parsedDate.format('YYYY-MM-DD'));
                                            }
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label style={styles.label}>
                                    মন্তব্য (সংক্ষিপ্ত):
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '80px' }}
                                    value={hearingDate.comment || ''}
                                    onChange={(e) => updateHearingDate(index, 'comment', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>









            {/* File Upload Section - Multiple Documents */}
            <div style={styles.uploadSection}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                    <h3 style={styles.uploadHeader}>
                        সংযুক্তি
                    </h3>
                    <button
                        type="button"
                        onClick={addDocument}
                        style={styles.greenAddButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#16a34a'}
                    >
                        <i className="fas fa-plus" style={{ fontSize: '12px' }}></i>
                    </button>
                </div>

                {formData.documents.map((doc, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>

                        {/* Document Name */}
                        <input
                            type="text"
                            // placeholder="ডকুমেন্টের নাম"
                            value={doc.name}
                            onChange={(e) => {
                                const updatedDocs = [...formData.documents];
                                updatedDocs[index].name = e.target.value;
                                setFormData({ ...formData, documents: updatedDocs });
                            }}
                            style={{ ...styles.formInput, flex: '1', width: "30%" }}
                        />

                        {/* File Upload */}
                        <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                const updatedDocs = [...formData.documents];
                                updatedDocs[index].file = file;
                                setFormData({ ...formData, documents: updatedDocs });
                            }}
                            style={{ flex: '1', width: "40%", backgroundColor: '#f3f4f6', border: '1px solid #cbd5e1', borderRadius: '4px', padding: '8px' }}
                        />

                        {/* Remove Button */}
                        <button
                            type="button"
                            onClick={() => removeDocument(index)}
                            style={{
                                width: '24px',
                                height: '24px',
                                backgroundColor: '#ef4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                        >
                            <i className="fas fa-minus" style={{ fontSize: '12px' }}></i>
                        </button>
                    </div>
                ))}
            </div>


            {/* Submit Button */}
            <div className="text-center">
                <button
                    type="submit"
                    style={styles.submitButton}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0f766e'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#0d9488'}
                    onClick={handleSubmit}
                >
                    সংরক্ষণ
                </button>
            </div>




        </div>
    );
};

export default AppelCaseGenralForm;